<template>
    <ThePage>
        <dash-graph class="mb-5" :range.sync="range" :payment-type.sync="ptype" :chart="chart">
            <template v-slot:help>
                <a target="_blank" :href="getKBLink('dashboard')" class="btn btn-outline-primary text-center mr-2"><i class="tlm-icon-question-circle" /></a>
            </template>
        </dash-graph>

        <div class="d-flex justify-content-between mb-3">
            <div class="font-weight-bold">Торговые автоматы</div>

            <div class="d-none d-md-block">
                <small>Выгрузить статистику:</small>
                <button type="button" class="btn btn-outline-primary ml-2" @click.prevent="getFile('csv')">CSV</button>
                <button type="button" class="btn btn-outline-primary ml-2" @click.prevent="getFile('xlsx')"><i class="tlm-icon-excel mr-2" /> Excel</button>
            </div>
        </div>

        <div class="d-flex flex-column flex-lg-row">
            <div class="vm-state-counters d-flex flex-row flex-lg-column">
                <div class="card">
                    <div class="card-body text-success">
                        <div class="counter">{{ usage.count_vm_online }}</div>
                        <small class="text-nowrap">Онлайн</small>
                    </div>
                </div>

                <div class="card">
                    <div class="card-body text-black-50">
                        <div class="counter">{{ usage.count_vm_disconnected }}</div>
                        <small class="text-nowrap">Нет связи</small>
                    </div>
                </div>

                <div class="card">
                    <div class="card-body text-danger">
                        <div class="counter">{{ usage.count_vm_offline }}</div>
                        <small class="text-nowrap">Не работает</small>
                    </div>
                </div>

                <div v-show="usage.count_vm_modemless > 0" class="card">
                    <div class="card-body text-primary">
                        <div class="counter">{{ usage.count_vm_modemless }}</div>
                        <small class="text-nowrap">Без модема</small>
                    </div>
                </div>
            </div>

            <vm-list :is-infinite="true" :vms="vms" :has-crt="hasCrt" :has-loading="hasLoading" class="flex-grow-1 ml-lg-3">
                <template v-slot:moar>
                    <infinite-loading spinner="waveDots" :identifier="$route.fullPath" @infinite="loadVms">
                        <span slot="no-more" />
                        <template v-slot:no-results>Вы пока не добавили ни одного торгового автомата.</template>
                    </infinite-loading>
                </template>
            </vm-list>
        </div>
    </ThePage>
</template>

<script>
import ThePage from '@/components/ThePage'
import DashGraph from '@/components/DashGraph'
import VmList, { getFile } from '@/components/VmList'
import InfiniteLoading from 'vue-infinite-loading'
import store from '@/store'

import DateCacheService, { oneWeekAgoRange } from '@/services/DateCacheService'
import KBLinksService from '@/services/KBLinksService'

function resolveDefaultRange() {
    return DateCacheService.getFormatted('dash', oneWeekAgoRange)
}

const beforeRoute = async (to, from, next) => {
    if (!to.query.since || !to.query.until) {
        return next({ name: to.name, query: resolveDefaultRange() })
    }

    // LITE-114
    // Некоторые пользователи (или сотрудники) редко пользуются Лайтом/ЛХ.
    // У них может в локалсторадже остаться очень старый интервал дат, бек на него ругнется своей валидацией.
    if (to.query.since && DateCacheService.isTooFar(to.query.since)) {
        DateCacheService.forget('dash')
        return next({ name: to.name })
    }

    await Promise.all([
        store.dispatch('vms/fetchAll', { ...to.query, vends: 1, loading: 1 }),
        store.dispatch('company/usage/fetch'),
        store.dispatch('vends/fetchChart', { params: to.query })
    ])

    next()
}

export default {
    components: {
        ThePage,
        DashGraph,
        VmList,
        InfiniteLoading
    },

    props: {
        filter: {
            type: Object,
            default: _ => ({ })
        }
    },

    computed: {
        vms() {
            return this.$store.state.vms.data || []
        },

        usage() {
            return this.$store.state.company.usage.data
        },

        hasCrt() {
            return this.$store.getters['company/hasCrt']
        },

        hasLoading() {
            return this.$store.getters['company/hasLoading']
        },

        range: {
            set({ alias, ...range }) {
                alias
                    ? DateCacheService.setAlias('dash', alias)
                    : DateCacheService.set('dash', range)

                this.applyFilter({ ...range, page: 1 })
            },

            get() {
                return this.filter
            }
        },

        ptype: {
            set(ptype) {
                this.applyFilter({ ptype, page: 1 })
            },

            get() {
                return this.filter.ptype || 0
            }
        },

        chart() {
            return this.$store.state.vends.chart
        }
    },

    methods: {
        getFile,

        async loadVms(infinite) {
            const hasMore = await store.dispatch('vms/loadMore', { id: this.$route.params.id, params: this.$route.query })

            if (hasMore) {
                infinite.loaded()
            } else {
                if (this.vms.length > 0) {
                    infinite.loaded()
                }

                infinite.complete()
            }
        },

        getKBLink(key) {
            return KBLinksService.get(key)
        }
    },
    beforeRouteEnter: beforeRoute,
    beforeRouteUpdate: beforeRoute
}
</script>
